import { useCallback, useState } from 'react'
import GenericDropdown from '../../generic/genericDropdown'
import Link from '@mui/material/Link'
import RecalibrateBalancesModal from './RecalibrateBalancesModal'

const TransactionsTableDropdown = ({ bankAccountName, bankAccountId, onRecalibrate }) => {
  const [recalibrateModalVisible, setRecalibrateModalVisible] = useState(false)

  const handleRecalClick = useCallback(() => {
    setRecalibrateModalVisible(true)
  }, [setRecalibrateModalVisible])

  const handleCloseRecal = useCallback(() => {
    setRecalibrateModalVisible(false)
  }, [setRecalibrateModalVisible])

  const dropdownItems = [
    <Link component='button' underline='none' onClick={handleRecalClick}>
      Recalibrate Balances
    </Link>,
  ]

  return (
    <>
      <GenericDropdown dropdownItems={dropdownItems} />
      {recalibrateModalVisible && (
        <RecalibrateBalancesModal
          bankAccountId={bankAccountId}
          modalVisible={recalibrateModalVisible}
          handleCancelModal={handleCloseRecal}
          bankAccountName={bankAccountName}
          onRecalibrate={onRecalibrate}
        />
      )}
    </>
  )
}

export default TransactionsTableDropdown
